import Image from "next/legacy/image"
import { useEffect, useState, useRef } from "react"
import { renderTime, convertSeccondToTimePlay, renderTimeFromNow } from "utils/time"
import Link from "next/link"
import axios from "axios"
import TagPremium from "components/TagPremium"
import config from "lib/config"

let calling = false

export default function BoxRelatedTo({ query }) {
  const [loading, setLoading] = useState(false)
  const [rows, setRows] = useState([])
  const pageNum = useRef(0)
  const maxCount = useRef(50)
  const wapper = useRef()

  async function fetch(list) {
    try {
      pageNum.current = pageNum.current + 1
      const res = await axios.get(`${config.BASE_API_URL}/publish/event/related-to/`, {
        params: {
          ...query,
          page_num: pageNum.current,
          page_size: 10
        }
      })
      const { data, count } = res.data
      maxCount.current = count
      setRows([...list, ...data])
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
      calling = false
    }
  }

  useEffect(() => {
    function onScroll(e) {
      const { scrollHeight, scrollTop, offsetHeight } = e.target
      if (scrollTop + 350 > scrollHeight - offsetHeight) {
        if (!calling) {
          setLoading(true)
        }
      }
    }
    if (wapper.current) {
      wapper.current.addEventListener("scroll", onScroll)
      return () => {
        if (wapper.current) wapper.current.removeEventListener("scroll", onScroll)
      }
    }
  }, [])

  useEffect(() => {
    if (loading && maxCount.current > rows.length) fetch(rows)
  }, [loading])

  useEffect(() => {
    pageNum.current = 0
    fetch([])
  }, [query])

  // useEffect(() => {
  //   if (__link.current) {
  //     router.push(__link.current)
  //   }
  // }, [userInfo])

  return (
    <div className="bg-dark rounded">
      {/* <div className="text-dark-100 px-4 py-3 border-b border-gray-700 text-lg font-semibold">Video liên quan</div> */}
      <div className="p-4 overflow-y-auto overflow-x-hidden scroll__video h-[61vh]" ref={wapper}>
        {rows.length > 0 ? (
          rows?.map(
            ({
              type,
              name,
              id,
              created,
              is_live,
              duration,
              status,
              start_time,
              thumbnail_horizontal,
              package_type,
              is_url_external,
              url_external,
              is_monopoly = false
            }) => {
              const _link = `/video?id=${id}&type=${type}`
              return (
                <div className="mb-2" key={id}>
                  <Link
                    target={is_url_external && url_external ? "_blank" : ""}
                    href={is_url_external ? url_external : _link}
                  >
                    <div className="flex" role="button" tabIndex="0" onKeyPress={() => {}}>
                      <div className="mr-3 relative">
                        <div className="fix_img shadow-sm" style={{ minWidth: 143 }}>
                          <Image
                            height={81}
                            width={143}
                            className="rounded-lg"
                            src={
                              thumbnail_horizontal ||
                              "https://stvinaprod.vtvcab.vn/797864df-e895-426e-8573-210ca0d4b26c.png"
                            }
                          />
                        </div>
                        {status === "live" && is_live && (
                          <div className="absolute shadow bottom-2 right-2 bg-dark-50 rounded-xl flex  items-center px-1">
                            <div className=" rounded-full h-2 w-2 bg-red-500 mr-1"></div>
                            <div className="text-dark-800 font-semibold" style={{ fontSize: 10 }}>
                              LIVE
                            </div>
                          </div>
                        )}
                        {!is_live && (
                          <div className="absolute text-white shadow text-xs bottom-1 right-1 bg-black bg-opacity-80 rounded flex space-x-2 items-center px-1">
                            <div>{convertSeccondToTimePlay(duration)}</div>
                          </div>
                        )}
                        <TagPremium package_type={package_type} />
                        {is_monopoly && (
                          <div className="absolute  top-0 right-2 w-[32px] h-[25px]">
                            <Image
                              src={"https://stvinaprod.vtvcab.vn/1602635b-7a7e-4dc0-aab3-f596b5635898.png"}
                              width={480}
                              height={350}
                              alt={name}
                              onError={() => "https://stvinaprod.vtvcab.vn/4ab5f0e3-d616-4834-9485-d54b0ebb7115.png"}
                            />
                          </div>
                        )}
                      </div>

                      <div className="flex-grow text-dark-300 text-sm">
                        <div className="text-dark-100 md:font-medium mb-1 line-clamp-3 font-bold md:text-sm text-xs">
                          {name}
                        </div>
                        <div className="text-dark-500 text-xs">
                          {status === "live" && is_live && (
                            <time dateTime={new Date(start_time)} className="text-dark-500 text-xs">
                              {is_live ? renderTime(start_time) : renderTimeFromNow(created)}
                            </time>
                          )}
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              )
            }
          )
        ) : (
          <div></div>
        )}
      </div>
      {/* <Modal isOpen={isOpen} onCancel={onCancel}>
        <div className="p-6 text-center">
          <div className="py-4">Bạn cần đăng nhập để xem nội dung này</div>
          <button onClick={onShowModalLogin} className="bg-primary-700 py-2 px-4 rounded text-dark-100">
            Đăng nhập
          </button>
        </div>
      </Modal> */}
    </div>
  )
}
